// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */
.max-width-image {
    /* width: 1350px; */
    max-height: 400px; 
    height: 450px;
}

.max-height-image {
    max-height: 400px; 
}

.max-image {
    /* max-height: 100px;
    max-width: 100px;  */
    justify-content: center;
    align-items: center;
}
.map-container{
    justify-content: center;
    align-items: center;
    font-family: sans-serif;
    text-align: center;
}
path {
    pointer-events: all;
    opacity: 0.50;
}
path:hover {
    opacity:1;
    cursor: pointer;
}
.state-container {
    overflow: auto; 
    min-height: 800px;
    height: auto;
    display: flex; /* Use flexbox layout */
    flex-direction: column; /* Arrange children vertically */
    align-items: center;
}
.state-container>p{
    text-align: justify;
    text-align-last: center;
    max-width: 60%;
}

.state-container>ol{
    text-align: justify;
    text-align-last: center;
    max-width: 50%;
}
.state-usa-gif{
    display: flex;
    align-items: center;
}
.state-usa-gif>img{
    width: 100%;
    height: 100%;
}
.state-dropdown {
    width: 200px; 
    padding: 8px;
    border: 1px solid #ccc; 
    border-radius: 4px; 
    font-size: 16px; 
}

.site-dropdown {
    width: 100%; 
    /* padding: 20%; */
    border: 100% solid #ccc; 
    border-radius: 4px; 
    font-size: 16px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
}
.site-dropdown-menu{
    width: 100%; 
    /* padding: 20%; */
    border: 100% solid #ccc; 
    border-radius: 4px; 
    font-size: 16px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    /* margin-right: -58%; */
    margin-left: 32%;
    margin-bottom: 1%;
}
.site-date-dropdown {
    /* width: 100%;  */
    /* border: 100% solid #ccc; 
    border-radius: 4px; 
    font-size: 16px;
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center; */
    
    margin-top: 2%; 
}

.site-day-dropdown {
    margin-top: 12%; 
}

/* .site-date-dropdown>p{
    text-align: left;
    text-align-last: center;
    max-width: 50%;
} */

.site-event-dropdown{
    /* display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center; */
    display: flex;
    justify-content: center;
    align-items: flex-start; 
    flex-wrap: wrap; 
}

p {
    text-align: center;
}

h1{
    text-align: center;
}

.date-container {
    justify-content: center;
    align-items: center;
    display: flex;
    flex-flow: column;
}

.day-container {
    justify-content: center;
    align-items: center;
    display: flex;
    flex-flow: column;
}

.date-dropdown {
    text-align: 'center' ;
    margin-top: -20%;
    margin-bottom: 22%;
    margin-right: 27%;
}

.day-dropdown {
    text-align: 'center' ;
    margin-top: -14%;
    margin-bottom: 22%;
    margin-right: 0%;
}

.heading-button-displays{
    display: flex;
    flex-flow: row;
    text-align: center;
    justify-content: center;
    gap: 120px;
}

.heading-button-day-displays{
    display: flex;
    flex-flow: row;
    text-align: center;
    justify-content: center;
    gap: 120px;
}`, "",{"version":3,"sources":["webpack://./src/components/styles.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;wBACoB;IACpB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,SAAS;IACT,eAAe;AACnB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,aAAa,EAAE,uBAAuB;IACtC,sBAAsB,EAAE,gCAAgC;IACxD,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB;;;;;;0BAMsB;;IAEtB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;GAIG;;AAEH;IACI;;;0BAGsB;IACtB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;AACd","sourcesContent":["/* styles.css */\r\n.max-width-image {\r\n    /* width: 1350px; */\r\n    max-height: 400px; \r\n    height: 450px;\r\n}\r\n\r\n.max-height-image {\r\n    max-height: 400px; \r\n}\r\n\r\n.max-image {\r\n    /* max-height: 100px;\r\n    max-width: 100px;  */\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.map-container{\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-family: sans-serif;\r\n    text-align: center;\r\n}\r\npath {\r\n    pointer-events: all;\r\n    opacity: 0.50;\r\n}\r\npath:hover {\r\n    opacity:1;\r\n    cursor: pointer;\r\n}\r\n.state-container {\r\n    overflow: auto; \r\n    min-height: 800px;\r\n    height: auto;\r\n    display: flex; /* Use flexbox layout */\r\n    flex-direction: column; /* Arrange children vertically */\r\n    align-items: center;\r\n}\r\n.state-container>p{\r\n    text-align: justify;\r\n    text-align-last: center;\r\n    max-width: 60%;\r\n}\r\n\r\n.state-container>ol{\r\n    text-align: justify;\r\n    text-align-last: center;\r\n    max-width: 50%;\r\n}\r\n.state-usa-gif{\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.state-usa-gif>img{\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n.state-dropdown {\r\n    width: 200px; \r\n    padding: 8px;\r\n    border: 1px solid #ccc; \r\n    border-radius: 4px; \r\n    font-size: 16px; \r\n}\r\n\r\n.site-dropdown {\r\n    width: 100%; \r\n    /* padding: 20%; */\r\n    border: 100% solid #ccc; \r\n    border-radius: 4px; \r\n    font-size: 16px;\r\n    display: flex;\r\n    flex-flow: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.site-dropdown-menu{\r\n    width: 100%; \r\n    /* padding: 20%; */\r\n    border: 100% solid #ccc; \r\n    border-radius: 4px; \r\n    font-size: 16px;\r\n    display: flex;\r\n    flex-flow: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    /* margin-right: -58%; */\r\n    margin-left: 32%;\r\n    margin-bottom: 1%;\r\n}\r\n.site-date-dropdown {\r\n    /* width: 100%;  */\r\n    /* border: 100% solid #ccc; \r\n    border-radius: 4px; \r\n    font-size: 16px;\r\n    display: flex;\r\n    flex-flow: row;\r\n    justify-content: center;\r\n    align-items: center; */\r\n    \r\n    margin-top: 2%; \r\n}\r\n\r\n.site-day-dropdown {\r\n    margin-top: 12%; \r\n}\r\n\r\n/* .site-date-dropdown>p{\r\n    text-align: left;\r\n    text-align-last: center;\r\n    max-width: 50%;\r\n} */\r\n\r\n.site-event-dropdown{\r\n    /* display: flex;\r\n    flex-flow: row;\r\n    justify-content: center;\r\n    align-items: center; */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: flex-start; \r\n    flex-wrap: wrap; \r\n}\r\n\r\np {\r\n    text-align: center;\r\n}\r\n\r\nh1{\r\n    text-align: center;\r\n}\r\n\r\n.date-container {\r\n    justify-content: center;\r\n    align-items: center;\r\n    display: flex;\r\n    flex-flow: column;\r\n}\r\n\r\n.day-container {\r\n    justify-content: center;\r\n    align-items: center;\r\n    display: flex;\r\n    flex-flow: column;\r\n}\r\n\r\n.date-dropdown {\r\n    text-align: 'center' ;\r\n    margin-top: -20%;\r\n    margin-bottom: 22%;\r\n    margin-right: 27%;\r\n}\r\n\r\n.day-dropdown {\r\n    text-align: 'center' ;\r\n    margin-top: -14%;\r\n    margin-bottom: 22%;\r\n    margin-right: 0%;\r\n}\r\n\r\n.heading-button-displays{\r\n    display: flex;\r\n    flex-flow: row;\r\n    text-align: center;\r\n    justify-content: center;\r\n    gap: 120px;\r\n}\r\n\r\n.heading-button-day-displays{\r\n    display: flex;\r\n    flex-flow: row;\r\n    text-align: center;\r\n    justify-content: center;\r\n    gap: 120px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
